import React from 'react';

import type { HubShellPlugin } from './hubShellPluginType';
import { HubShellContentComponent } from './ui/HubShellContentComponent';

/**
 * Hub shell editor plugin.
 *
 * Injects the hub Navbar and Footer as visual chrome inside the editor's
 * content area so the author sees a faithful WYSIWYG representation of how
 * the page will appear in view mode.
 *
 * The plugin relies on the `contentComponent` editor hook which renders
 * inside the editor's React tree (preserving all React context) and uses DOM
 * portals to place the Navbar and Footer in the same flex column as the
 * ProseMirror editable div. This ensures they resize together with the ADF
 * content whenever the editor config panel opens on the right side.
 *
 * Consumers must hide the HubAppShell Navbar (via `hideNavbar` prop) when
 * this plugin is active to avoid rendering two navbars.
 */
export const hubShellPlugin: HubShellPlugin = () => ({
	name: 'hubShell',

	contentComponent({ editorView }) {
		if (!editorView) {
			return null;
		}
		return <HubShellContentComponent editorView={editorView} />;
	},
});
